import { preprocessData } from "../utils/processData";
import { buildTree } from "../utils/buildTree";

export const useSidebarTree = (data) => {
  const cleanData = preprocessData(data);
  const treeData = buildTree(cleanData);
  return treeData;
};
